import {
	Component,
	EventEmitter,
	Input,
	Output,
	ChangeDetectionStrategy,
} from "@angular/core"
import { COMMON_IMPORTS } from "../common-imports"
import { getIds } from "@app/helpers"
import { ApiService } from "@app/services/api.service"
import { LangService } from "@app/services/lang.service"
import { ModalService } from "@app/services/modal.service"
import { StoreService } from "@app/services/store.service"
import { LangValPipe } from "@app/utils/lang-val.pipe"
import { ModalWrapComponent } from "@app/modal-wrap/modal-wrap.component"
import { ChoosePersonComponent } from "@app/choose-person/choose-person.component"
import { GenTableDisplayComponent } from "@app/gen-table-display/gen-table-display.component"

@Component({
	selector: "app-gen-table-header-btn-checked",
	imports: [
		COMMON_IMPORTS,
		LangValPipe,
		ModalWrapComponent,
		ChoosePersonComponent,
		GenTableDisplayComponent,
	],
	changeDetection: ChangeDetectionStrategy.Eager,
	template: `
		@if (btn?.textOnly) {
			<button
				class="btn btn-primary"
				(click)="open()"
			>
				{{ btn.hoverLang | langVal }}
			</button>
		} @else {
			<button
				class="btn"
				[titleLang]="btn.hoverLang"
				(click)="open()"
				[icon]="btn.icon"
			></button>
		}
		@switch (modalProps?.name) {
			@case ("choose-person") {
				<app-modal-wrap (onClose)="modalProps = null">
					<app-choose-person
						(onClose)="modalProps = null; handleChoosePersonClose($event)"
					/>
				</app-modal-wrap>
			}
			@case ("table-display-contactways") {
				<app-modal-wrap
					(onClose)="modalProps = null"
					title="contactways"
					modalWrapperClass="modal-wide"
				>
					<app-gen-table-display
						(onClose)="
							modalProps = null; $event && sendMultipleFinresources($event)
						"
						tableName="contactways"
						[filterField]="modalProps.filterField"
						[filterFieldValue]="filterFieldValue"
						fieldNameInItemToDisplay="contactway"
						isCheckItems
						[filterFieldApiObject]="modalProps.filterFieldApiObject"
						[emailsAndPhoneValidation]="modalProps.emailsAndPhoneValidation"
					/>
				</app-modal-wrap>
			}
		}
	`,
})
export class GenTableHeaderBtnCheckedComponent {
	modalProps: any = null
	@Input() btn: any
	@Input() filterField: string = ""
	@Input() filterFieldValue: any = null
	@Input() checkedRows: any[] = []
	@Output() onIsSendingChange = new EventEmitter()

	constructor(
		public lang: LangService,
		public apiService: ApiService,
		public store: StoreService,
		public modalService: ModalService
	) {}

	async open() {
		const { funcToRunOnReturn, fieldsToUpdate } = this.btn
		if (funcToRunOnReturn == "printMultipleExpenses") {
			this.printMultipleExpenses()
			return
		}
		if (funcToRunOnReturn == "sendMultipleExpenses") {
			this.sendMultipleExpenses()
			return
		}
		if (funcToRunOnReturn == "printMultipleFinresources") {
			this.printMultipleFinresources()
			return
		}
		//sendMultipleFinresources
		if (this.filterField == "user_id") {
			this.sendMultipleFinresources([], this.filterFieldValue)
			return
		}

		this.modalProps = {
			name: "table-display-contactways",
			filterField: fieldsToUpdate.filterField,
			...this.store.phoneEmailValidationAttrs(),
		}
	}

	async printMultipleExpenses() {
		const ids = getIds(this.checkedRows)
		if (!ids.length) {
			return
		}
		for (let id of ids) {
			await this.store.downloadToastFunc(async () => {
				const res: any = await this.apiService.download("get_expense_file", {
					id,
				})
				this.apiService.downloadFile(res, `expense_${id}_copy.pdf`)
			})
		}
	}
	async handleChoosePersonClose(arr: any[]) {
		this.onIsSendingChange.emit(true)
		await this.apiService.post("email_multiple_expenses", {
			ids: getIds(this.checkedRows),
			contactway_ids: arr.map(({ id }) => id),
		})
		this.modalService.openToast("sent_to")
		this.onIsSendingChange.emit(false)
	}
	sendMultipleExpenses() {
		if (!getIds(this.checkedRows).length) {
			return
		}
		this.modalProps = { name: "choose-person" }
	}
	async printMultipleFinresources() {
		const selectedDocuments = this.checkedRows
		if (!selectedDocuments.length) {
			return
		}
		for (let obj of selectedDocuments) {
			const type = obj.doctype || "document"

			await this.store.downloadToastFunc(async () => {
				const res: any = await this.apiService.download(
					"print_make_finresource",
					{ id: obj.id, doctype: type }
				)
				let name =
					obj?.doc_type == "upload"
						? obj.doc_name
						: `${type}_${obj.id}_copy.pdf`
				this.apiService.downloadFile(res, name)
			})
		}
	}
	async sendMultipleFinresources(
		arrContactways: any[] = [],
		user_id: number | null = null
	) {
		//get chosen items

		const finresources = this.checkedRows.map((row) => ({
			id: row.id,
			doctype: row.doctype || "document",
		}))
		if (!finresources.length) {
			return
		}
		const contactway_ids = arrContactways.map((row) => row.id)
		this.onIsSendingChange.emit(true)
		await this.apiService.post("email_multiple_finresources", {
			finresources,
			contactway_ids,
			user_id,
		})
		this.modalService.openToast("sent_to")
		this.onIsSendingChange.emit(false)
	}
}
